import ToggleSelect from './toggle-select';

new ToggleSelect(
  'js-product-finance-toggle-type',
  'js-product-finance-prices',
  'js-product-finance-toggle-bg',
  'js-product-finance-label',
);
